/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Templates_Browse_AllInputs */



/**
* | output |
* | --- |
* | "Browse all templates" |
*
* @param {Agent_Templates_Browse_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_templates_browse_all = /** @type {((inputs?: Agent_Templates_Browse_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Templates_Browse_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Vorlagen ansehen")
	return /** @type {LocalizedString} */ ("Browse all templates")
});